import { Link } from "react-router-dom";
import { Logo } from "@/components/shared/Logo";
import { socialLinks } from "@/data/mockData";

export const Footer = () => {
  const year = new Date().getFullYear();
  const exploreRoutes = [
    { l: "News", h: "/news", route: true },
    { l: "Articles", h: "/articles", route: true },
    // {
    //   l: "Founders/Investors",
    //   h: "/founders-investors",
    //   route: true,
    // },
    // { l: "Mentors", h: "/mentors", route: true },
    // { l: "Cohort", h: "/cohort", route: true },
  ];

  return (
    <footer
      data-testid="main-footer"
      className="relative bg-black border-t border-white/10 px-6 md:px-10 lg:px-16 pt-20 pb-8"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 border-b border-white/10 pb-16">
        <div className="md:col-span-5">
          <Link
            to="/"
            aria-label="Startup Unplugged — Home"
            data-testid="footer-logo"
          >
            <Logo className="max-w-[250px]" testid="footer-brand-logo" />
          </Link>
          <p className="mt-5 max-w-md text-bone-muted text-sm md:text-base leading-relaxed">
            A media platform for the people building, backing, and breaking
            things across Delhi NCR. Stories. Conversations. Community.
          </p>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-bone-muted">
            Gurugram · Delhi · Noida
          </p>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-flare mb-5">
            Explore
          </p>
          <ul className="space-y-3 text-sm">
            {exploreRoutes.map((x) =>
              x.route ? (
                <li key={x.l}>
                  <Link
                    to={x.h}
                    data-testid={`footer-explore-${x.l.toLowerCase()}`}
                    className="hover:text-flare transition-colors"
                  >
                    {x.l}
                  </Link>
                </li>
              ) : (
                <li key={x.l}>
                  <a
                    href={x.h}
                    data-testid={`footer-explore-${x.l.toLowerCase()}`}
                    className="hover:text-flare transition-colors"
                  >
                    {x.l}
                  </a>
                </li>
              ),
            )}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-flare mb-5">
            Work with us
          </p>
          <ul className="space-y-3 text-sm">
            {[
              { l: "Partner With Us", h: "/contact" },
              { l: "Advertise", h: "/contact" },
              { l: "Contact", h: "/contact" },
              { l: "About Us", h: "/about" },
            ].map((x) => (
              <li key={x.l}>
                <Link
                  to={x.h}
                  data-testid={`footer-work-${x.l.toLowerCase().replace(/\s/g, "-")}`}
                  className="hover:text-flare transition-colors"
                >
                  {x.l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-flare mb-5">
            Follow
          </p>
          <ul className="space-y-3 text-sm">
            {socialLinks.map((s) => (
              <li key={s.label}>
                <a
                  href={s.href}
                  data-testid={`footer-social-${s.label.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                  className="hover:text-flare transition-colors flex items-center gap-2"
                >
                  <span className="w-3 h-px bg-white/30" />
                  {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.25em] text-bone-muted">
        <p>© {year} StartupUnplugged. Built with caffeine in NCR.</p>
        <div className="flex gap-6">
          <a href="#" className="hover:text-flare transition-colors">
            Privacy
          </a>
          <a href="#" className="hover:text-flare transition-colors">
            Terms
          </a>
        </div>
      </div>

      {/* Giant wordmark watermark */}
      <div aria-hidden className="relative mt-16 select-none overflow-hidden">
        <p
          className="font-display font-extrabold uppercase leading-[0.8] tracking-tighter text-bone/[0.04] whitespace-nowrap"
          style={{ fontSize: "clamp(80px, 18vw, 360px)" }}
        >
          UNPLUGGED · NCR
        </p>
      </div>
    </footer>
  );
};
